/**
 * ULD管理模块入口
 * 导出ULD管理页面和相关组件
 */

import UldManagementPage from "./UldManagementPage";

export default UldManagementPage;
